export default {
  FAQ_btn: 'Допомога',
  privacyPolicy_btn: 'Політика конфіденційності',
  impressum_btn: 'Контакти',
  contact_us_btn: 'Зв\'язатися з нами',
}



// WEBPACK FOOTER //
// ./src/locale/uk-UA/login.js